module.exports = __webpack_public_path__ + "img/wechat-inner.ee27499e.svg";